import { render } from "./Main-Menu.vue?vue&type=template&id=2d473b63&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./Main-Menu.vue?vue&type=script&lang=js"
export * from "./Main-Menu.vue?vue&type=script&lang=js"

import "./Main-Menu.vue?vue&type=style&index=0&id=2d473b63&lang=scss&scoped=true"

import exportComponent from "D:\\svn\\RD\\code\\Branches\\ZWV2.4.0\\V3.0.0\\hiwoo-cloud\\cloud-pedestal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d473b63"]])

export default __exports__